import Vue from "vue";
import Vuex from "vuex";
import globalstates from "./modules/globalstates";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    globalstates
  }
});
